import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  CompactView,
  getCatalogReferenceView,
  StandardView,
  updateDhCatalogReferenceViewRequestSaga,
} from 'domains/user';
import { Flex, MarginBox, Switch, Text } from 'UI';

const CatalogSettings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const referenceView = useSelector(getCatalogReferenceView);

  const handleViewChange = (isCompact: boolean) => {
    isCompact ? setCompactView() : setStandardView();
  };

  const setCompactView = () => {
    dispatch(updateDhCatalogReferenceViewRequestSaga(CompactView));
  };

  const setStandardView = () => {
    dispatch(updateDhCatalogReferenceViewRequestSaga(StandardView));
  };

  return (
    <Flex direction={'column'} gap={25} data-cy={'catalog-section'}>
      <Text type="heading4">{t('settings.general_settings.catalog_settings.title', 'Catalog')}</Text>
      <Text type={'text'}>
        {t(
          'settings.general_settings.catalog_settings.description',
          'Customize the display of references in the catalog.',
        )}
      </Text>
      <Flex>
        <Text type="base" bold>
          {t(
            'settings.general_settings.catalog_settings.switch.title',
            'Display the compact version of the references.',
          )}
        </Text>
        <MarginBox ml={15} />
        <Switch
          onChange={handleViewChange}
          checked={referenceView === CompactView}
          data-cy={'toggle-short-references'}
        />
      </Flex>
    </Flex>
  );
};

export default CatalogSettings;
